//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------


export const handleListOneGameCategory = (id) => async (dispatch) => {
    try {
        const video = await apis.get('one_game_category', `/list_gallery/${id}`);

        if (Array.isArray(video)) {
            await dispatch(Actions.listOneGameCategory(video));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing one game category',
                error,
                module: 'ONE_GAME_CATEGORY',
                operation: 'LIST_ORGANIZATION_GROUP_CLASS'
            })
        }
    }
};

export const handleCreateOneGameCategory  = (data) => async (dispatch) => {
    try {
        const videos = await apis.post('one_game_category', `/create_gallery`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.createOneGameCategory(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating one game category',
                error,
                module: 'ONE_GAME_CATEGORY',
                operation: 'CREATE_ORGANIZATION_GROUP_CLASS'
            })
        }
    }
};

// Removed unused handleDeleteOneGameCategory

// Removed unused handleUpdateOneGameCategory
